import React from "react";

const TextEditorContent = ({ text, style }) => {
    return (
        <div style={style} className="ql-editor" dangerouslySetInnerHTML={{__html: text}}/>
    );
};

export default TextEditorContent;